import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceCardComponent } from './resource-card.component';
import { ResourceCardImageDirective } from './resource-card-image.directive';
import { ResourceCardImageMetaDirective } from './resource-card-image-meta.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ResourceCardComponent,
    ResourceCardImageDirective,
    ResourceCardImageMetaDirective,
  ],
  exports: [
    ResourceCardComponent,
    ResourceCardImageDirective,
    ResourceCardImageMetaDirective,
  ],
})
export class ResourceCardModule {}
